import React from "react";

export const SvgNextLogo = () => {
	return (
		<svg
			width="63"
			height="12"
			viewBox="0 0 63 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.864 0.0959997H5.024L12.624 7.584V0.0959997H16.304V12H12.624L4.544 4.112V12H0.864V0.0959997ZM18.3559 0.0959997H30.8999V2.8H22.0359V4.56H30.6919V7.28H22.0359V9.232H31.0599V12H18.3559V0.0959997ZM36.3521 12H31.7601L37.6801 5.984L31.8881 0.0959997H36.8801L40.2401 3.584L43.6001 0.0959997H48.1761L42.4641 5.904L48.3041 12H43.6161L39.9681 8.304L36.3521 12ZM53.9331 12V2.912H48.8131V0.0959997H62.8291V2.912H57.6931V12H53.9331Z"
				fill="#FF406A"
			/>
		</svg>
	);
};
